
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4a3428"}},[_c('path',{attrs:{"d":"m23.5705 6.93799-7.3515-2.4c-.1264-.05053-.2527-.05053-.4043 0l-7.35156 2.4c-.2526.07578-.42945.32841-.42945.60633v9.65048c0 .2779.17685.5053.42945.6064l7.35156 2.4c.0758.0252.1263.0252.2021.0252s.1263 0 .2022-.0252l7.3515-2.4253c.2526-.0758.4295-.3284.4295-.6063v-9.62528c0-.27792-.1769-.50528-.4295-.60633zm-8.1852 11.79791-6.08846-1.9958v-8.33688l2.42526.78315v4.72423c0 .3537.2779.6316.6316.6316s.6316-.2779.6316-.6316v-4.2947l2.4252.7831v8.3369zm.6315-9.44843-1.7178-.55582 1.2126-.42945c.3284-.1263.5052-.48.3789-.80843-.1263-.32841-.48-.48-.8084-.37894l-2.7031.98524-1.6927-.55575 5.3305-1.74318 5.3306 1.74318zm6.72 7.45263-2.4252.7831v-2.7284c0-.3536-.2779-.6316-.6316-.6316s-.6063.278-.6063.6316v3.158l-2.4253.7831v-8.3369l6.0884-1.99578z"}}),_c('path',{attrs:{"d":"m5.10316 8.22638h-4.471581c-.353685 0-.631579.27795-.631579.63157 0 .3537.277894.63158.631579.63158h4.471581c.35368 0 .63158-.27788.63158-.63158-.02527-.35362-.30316-.63157-.63158-.63157z"}}),_c('path',{attrs:{"d":"m5.10316 11.738h-4.471581c-.353685 0-.631579.2779-.631579.6316 0 .3536.277894.6316.631579.6316h4.471581c.35368 0 .63158-.278.63158-.6316 0-.3537-.30316-.6316-.63158-.6316z"}}),_c('path',{attrs:{"d":"m5.10316 15.2496h-4.471581c-.353685 0-.631579.2779-.631579.6316 0 .3536.277894.6316.631579.6316h4.471581c.35368 0 .63158-.278.63158-.6316 0-.3537-.30316-.6316-.63158-.6316z"}})])])
          )
        }
      }
    